import { render, staticRenderFns } from "./lawyer_add.vue?vue&type=template&id=029c89a0&scoped=true"
import script from "./lawyer_add.vue?vue&type=script&lang=js"
export * from "./lawyer_add.vue?vue&type=script&lang=js"
import style0 from "./lawyer_add.vue?vue&type=style&index=0&id=029c89a0&prod&scoped=true&lang=less"
import style1 from "./lawyer_add.vue?vue&type=style&index=1&id=029c89a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029c89a0",
  null
  
)

export default component.exports